// extracted by mini-css-extract-plugin
export default {"content":"Success_content__DlSi8","doneButton":"Success_doneButton__oe0iX","infoContainer":"Success_infoContainer__2wKqv"};